export const SERVICES = [
  {
    title: "CERAMIC COATING",
    slug: "ceramic-coating",
    image: "/assets/services/ceramic-coating.png"
  },
  {
    title: "OBD SCANNING",
    slug: "obd-scanning",
    image: "/assets/services/obd-scanning.png"
  },
  {
    title: "CAR DETAILING",
    slug: "car-detailing",
    image: "/assets/services/car-detailing.png"
  },
  {
    title: "CAR PAINTING",
    slug: "car-painting",
    image: "/assets/services/car-painting.png"
  },
  {
    title: "CAR CARE",
    slug: "car-care",
    image: "/assets/services/car-care.png"
  },
  {
    title: "CAR SPA",
    slug: "car-spa",
    image: "/assets/services/car-spa.png"
  },
  {
    title: "CAR AC",
    slug: "car-ac",
    image: "/assets/services/car-ac.png"
  },
  {
    title: "WRAP",
    slug: "wrap",
    image: "/assets/services/wrap.png"
  },
  {
    title: "PPF",
    slug: "ppf",
    image: "/assets/services/ppf.png"
  }
];

export const CONTACT = {
  phone1: "9626727777",
  phone2: "7448876665",
  website: "https://chennaicarcare.vercel.app",
  instagram: "@chennaicarcare",
  address:
    "187/52, Rukmani Nagar, 2nd Street, Perumbakkam, Medavakkam, Chennai, Tamil Nadu 600100"
};
